// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_EmployeeHistoryResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /payroll/employee_history
 * Gets employee payment execution history (with period info JOIN'd in)
 */
import type { Payroll_ExecutionRow } from './Payroll_ExecutionRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Payroll_EmployeeHistoryResponseDados = Payroll_ExecutionRow[];

export type Payroll_EmployeeHistoryResponse = ApiResponse<Payroll_EmployeeHistoryResponseDados>;

registerResponseContract('Payroll_EmployeeHistoryResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      id:                { type: 'number',  required: true },
      payroll_period_id: { type: 'number',  required: true },
      payment_rule_id:   { type: 'number',  required: true },
      user_id:           { type: 'string',  required: true },
      franchise_id:      { type: 'number',  required: true },
      despesa_id:        { type: 'number',  required: false },
      base_amount:       { type: 'string',  required: true },
      revenue_tracked:   { type: 'string',  required: false },
      expenses_tracked:  { type: 'string',  required: false },
      total_deductions:  { type: 'string',  required: true },
      net_amount:        { type: 'string',  required: true },
      calculation_meta:  { type: 'string',  required: false },
      status:            { type: 'string',  required: true },
      paid_at:           { type: 'string',  required: false },
      created_at:        { type: 'string',  required: true },
      updated_at:        { type: 'string',  required: true },
      rule_type:         { type: 'string',  required: false },
      rule_amount:       { type: 'string',  required: false },
    },
  },
})
